import { msg } from '@lingui/core/macro';

export const TENANT_TYPES = {
    TEST: 'Test',
    TRIAL: 'Trial',
    PROD: 'Prod',
};

export const TENANT_TYPE = 'tenantType';
export const TENANT_NAME = 'name';
export const TENANT_ALIAS = 'alias';
export const TENANT_LOGO = 'file';
export const TENANT_SHORT_NAME = 'displayName';
export const TENANT_TIME_FORMAT = 'timeFormat';
export const TENANT_DATE_FORMAT = 'dateFormat';

export const TENANT_ENTITY_TYPE = 'Tenant';

export const ALLOWED_TENANT_FIELDS = [
    TENANT_TYPE,
    TENANT_NAME,
    TENANT_ALIAS,
    TENANT_LOGO,
    TENANT_SHORT_NAME,
    TENANT_TIME_FORMAT,
    TENANT_DATE_FORMAT,
];

export const TENANT_INFO_STEP_TITLE = 'tenantInfo';

export const TENANT_BACKEND_FIELD = {
    NAME: 'Name',
    ALIAS: 'Alias',
    DISPLAY_NAME: 'DisplayName',
} as const;

export const SHARED_TENANT_INFO_HEADER = msg`Tenant information`;
export const SHARED_TENANT_INFO_SUB_INFO = msg`Enter basic information about your tenant`;
export const SHARED_TENANT_INFO_NAME_PLACEHOLDER = msg`Enter tenant name`;
export const SHARED_TENANT_INFO_ALIAS_PLACEHOLDER = msg`website`;
export const SHARED_TENANT_INFO_SHORT_NAME_PLACEHOLDER = msg`Max 200 chars, a–Z, 0–9, space only`;
export const SHARED_TENANT_INFO_CHANGE_LOGO = msg`Change logo`;
export const SHARED_TENANT_INFO_SAVE = msg`Save`;
export const SHARED_TENANT_INFO_LOGO_REQUIRED = msg`Logo is required`;
